/**
 * 首页Banner
 */
export type HomeBanner =  {
  /** 跳转地址 */
  jumpUrl: string,
  /** 跳转类型 */
  jumpType: number,
  /** 投放计划id */
  id: number,
  /** banner图片地址  */
  img: string,
  /** bi扩展字段信息 */
  reportInfo?: any,
  /** 自定义Bi上报值 */
  statClick?: string,
  /** 小程序 appid */
  appid?: string,
  /** 小程序 username */
  username?: string,
  /** 小程序 path */
  path?: string,
  /** 无障碍 */
  bannerAlt?: string,
};

/**
 * 跳转类型
 */
export enum JumpType {
  /** h5跳转 */
  H5 = 0,
  /** 小程序 */
  MiniProgram = 1,
}
